import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TicketListingViewModel } from '../../../../models/ticket';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { TicketTypes, StateTypes } from '../../../../common/enums';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { namespace } from 'vuex-class';

const UserStore = namespace(USER_MODULE_NAMESPACE);

@Component
class TicketListItem extends Vue {

  dtCurrentIndex: number | null;

  /**
   *
   */
  constructor() {
    super();
    this.dtCurrentIndex = null;
  }

  @UserStore.Getter userInfo: { id: number };
  @Prop({ required: true, type: [Object] })
  ticket: TicketListingViewModel;

  @Prop({ default: () => ({}), type: [Object] })
  characterProblems: { [key: string]: string }

  get lblSetting() {
    return {
      ...require('../../../../locales/ticket').default,
      ...require('../../../../locales/generic-labels').default,
    }
  }
  get coBlockName(): string {
    const name: string= this.ticket.block.name
    return name.length  > 30 ? name.slice(0,27) + "..." : name
  }
  get coAddress(): string {
    if (this.ticket.apartments.length > 0) {
      if (this.ticket.apartments.length === 1) {
        return this.apartmentFormatted(this.ticket.apartments[0])
      } else if (this.ticket.apartments.length === 2) {
        return this.apartmentFormatted(this.ticket.apartments[0]) + this.$t(this.lblSetting.ticketOneMoreValue)
      } else if (this.ticket.apartments.length > 2) {
        return this.apartmentFormatted(this.ticket.apartments[0]) + ' + ' + (this.ticket.apartments.length - 1) + this.$t(this.lblSetting.ticketOthersValue)
      }
    }
    return null;
    // return `${this.ticket.block.address.line1} ${this.ticket.block.address.zip_code} ${this.ticket.block.address.city} `
  }
  get coApartments(): string {

    if (this.ticket.apartments_formatted && this.ticket.apartments_formatted.length > 0) {
      return this.ticket.apartments_formatted
    }
    return null;
  }
  get coChannelId(): number {
    const channel = this.ticket.channel_id;//this.ticket.channels.find(item => item.type === TicketTypes.Public);
    if (channel)
      return channel;
    return null;
  }
  get coChannelLink(): string {
    if(!this.$route.meta.view_ticket_chat) return
    return `/ticket/${this.ticket.id}/channel/${this.coChannelId}`;
  }

  get coSubject(): string {
    return this.ticket.subject;
  }

  get coFullNameCreator(): string {
    //return this.getNameFromObject(this.ticket.creator[0]);
    return this.getNameFromObject(this.ticket.declarant[0]);
  }
  get coCreatedDate(): string {
    return DateTimeHelper.parseDate(this.ticket.createdAt);
  }
  get coFullNameManager(): string {
    if (this.ticket.managers_assigned.length > 0) {
      if (this.ticket.managers_assigned.length === 1) {
        return this.getNameFromObject(this.ticket.managers_assigned[0])
      } else if (this.ticket.managers_assigned.length === 2) {
        return this.getNameFromObject(this.ticket.managers_assigned[0]) + this.$t(this.lblSetting.ticketOneMoreValue)
      } else if (this.ticket.managers_assigned.length > 2) {
        return this.getNameFromObject(this.ticket.managers_assigned[0]) + ' + ' + (this.ticket.managers_assigned.length - 1) + this.$t(this.lblSetting.ticketOthersValue)
      }
    }
    return null;
  }
  get coZones():string {
    if(this.ticket.apartment_zone.length > 0){
      if(this.ticket.apartment_zone.length === 1)
        return this.ticket.apartment_zone[0].name
      if(this.ticket.apartment_zone.length === 2)
        return this.ticket.apartment_zone[0].name + this.$t(this.lblSetting.ticketOneMoreValue)
      if(this.ticket.apartment_zone.length > 2)
        return this.ticket.apartment_zone[0].name + ' + ' + (this.ticket.apartment_zone.length - 1) + this.$t(this.lblSetting.ticketOthersValue)
    }
  }
  get coIndependentContractotrMandate(): string {
    return this.getNameFromObject(this.ticket.independents_contractors_mandate[0])
  }

  get coPbTypeCode(): string {
    return this.ticket.pb_type_code;
  }

  get coLastAction(): string {
    // @ts-ignore
    return DateTimeHelper.parseDateTime(this.ticket.updatedAt)
  }

  get coMantenanceDate(): string {
    return null;
  }

  get coUnreadMessageNumber(): number {
    /*const owner = this.ticket.managers.find(x => x.id === this.userInfo.id);
    if (owner) {
      return owner.actor.nb_message_unread;
    }*/
    if (this.ticket.nb_message_unread > 0)
      return this.ticket.nb_message_unread
    return 0;
  }
  get coClosureReason(): string {
    return this.ticket.close_ticket_reason_name;
  }
  get isClosed(): boolean {
    return this.ticket.state === StateTypes.Close;
  }
  private getNameFromObject(obj: { firstname: string, lastname: string }): string {
    try {
      if (obj)
        return `${obj.firstname} ${obj.lastname}`;
      return '';
    }
    catch (error) {
      console.log(error)
    }
  }
  get coCharacterProblem(): string {
    const result = [
      this.characterProblems[this.ticket.fk_ticket_character_problem],
      this.characterProblems[this.ticket.fk_character_problem_level_2]
    ].filter(x => x && x.length > 0).join(' / ');

    return result
  }

  get coSubTitle(): string {
    return [
      this.ticket.ticket_pb_type.name,
      this.ticket.pb_character.name,
      this.ticket.pb_character_level_2.name
    ].filter(x => x && x.length > 0).join(' / ')
  }

  get coEquipments (): string {
    if (this.ticket.equipments.length > 0) {
      if (this.ticket.equipments.length === 1) {
        return this.ticket.equipments[0].name
      } else if (this.ticket.equipments.length === 2) {
        return this.ticket.equipments[0].name + this.$t(this.lblSetting.ticketOneMoreValue)
      } else if (this.ticket.equipments.length > 2) {
        return this.ticket.equipments[0].name + ' + ' + (this.ticket.equipments.length - 1) + this.$t(this.lblSetting.ticketOthersValue)
      }
    }
    return null;
  }

  getMantenanceDate(appointment) {
    if (appointment) {
      return DateTimeHelper.parseDate(appointment);
    }
    return null;
  }
  apartmentFormatted(apt) {
    if (apt.location_number)
      return apt.location_number + ' / ' + apt.apartment_number
    return apt.apartment_number
  }
  get priorityLevel(): any {
    return this.ticket.ticket_priority
  }
}

export default TicketListItem;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-list-item/index.ts